'use client';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { getActiveLang, translate } from '@openclassrooms/translations';

import { getLocalisationConfig } from '@openclassrooms/localisation/services';
import ApplyButton from '@openclassrooms/common-app/applications/components/ApplyButton';
import { ActionsContainer } from '@openclassrooms/common-app/layout/components';
import Breadcrumbs, {
  BreadcrumbsItem,
} from '@openclassrooms/common-app/navigation/components/Breadcrumbs';

import { styled } from '@classify/react-core-components/styles';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Button from '@classify/react-core-components/Button';
import Hero from '@classify/react-marketing-components/Hero';
import {
  HeroMediaContainer,
  MediaFormats,
} from '@classify/react-marketing-components/HeroMediaContainer';

const HeroSection = styled('section')(({ theme: { palette } }) => ({
  backgroundColor: palette.content.highlight.secondLevel.background,
}));

const getVideoUrl = () => {
  const activeLang = getActiveLang();

  let videoUrl = 'https://player.vimeo.com/video/726033342';
  if (activeLang === 'en') {
    videoUrl = 'https://player.vimeo.com/video/726033301';
  }
  return videoUrl;
};
const LearningExperienceHero = () => {
  const webinarLink = getLocalisationConfig('webinar.learningExperience.url');
  return (
    <HeroSection>
      <ContentWrapper>
        <Breadcrumbs>
          <BreadcrumbsItem>{translate('student_experience.header.breadcrumb')}</BreadcrumbsItem>
        </Breadcrumbs>

        <Hero
          title={translate('student_experience.header.title')}
          subheading={translate('student_experience.header.text')}
          media={
            <HeroMediaContainer format={MediaFormats.isVideo}>
              <iframe
                title={translate('student_experience.header.title')}
                src={getVideoUrl()}
                allowFullScreen
              />
            </HeroMediaContainer>
          }
        >
          <ActionsContainer sx={{ mt: 2 }}>
            <ApplyButton />
            {webinarLink && (
              <Button
                variant="tertiary"
                endIcon={<OpenInNewIcon />}
                target="_blank"
                href={`${webinarLink}?utm_source=website&utm_campaign=learning_experience_page`}
                data-event="Navigation|Redirection::External|Access webinar"
              >
                {translate('global.word.subscribe_webinar')}
              </Button>
            )}
          </ActionsContainer>
        </Hero>
      </ContentWrapper>
    </HeroSection>
  );
};

export default LearningExperienceHero;
